import { useState } from "react";
import { Box, Drawer, Fab, IconButton, Tooltip } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CloseIcon from "@mui/icons-material/Close";
import { useChatRail } from "./ChatRailProvider";
import { ChatRailBody } from "./ChatRailBody";
import { AgentTabStrip } from "./AgentTabStrip";
import { RunDetailDrawer } from "../RunDetailDrawer/RunDetailDrawer";

export function ChatRailMobile() {
  const { available, drawerRunId, setDrawerRunId } = useChatRail();
  const [open, setOpen] = useState(false);

  if (!available) return null;

  return (
    <>
      <Tooltip title="Open chat" placement="left">
        <Fab
          color="primary"
          aria-label="Open chat"
          onClick={() => setOpen(true)}
          sx={{
            position: "fixed",
            right: 16,
            bottom: 16,
            zIndex: (t) => t.zIndex.appBar - 1,
          }}
        >
          <ChatBubbleOutlineIcon />
        </Fab>
      </Tooltip>

      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: { height: "100vh", display: "flex", flexDirection: "row", overflow: "hidden" },
        }}
      >
        <AgentTabStrip />
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
          <ChatRailBody
            hideAgentStrip
            trailingHeader={
              <Tooltip title="Close chat" placement="left">
                <IconButton size="small" aria-label="Close chat" onClick={() => setOpen(false)}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            }
          />
        </Box>
      </Drawer>

      {drawerRunId && <RunDetailDrawer runId={drawerRunId} onClose={() => setDrawerRunId(null)} />}
    </>
  );
}
